import { type CreateUIAnalyticsEvent } from '@atlaskit/analytics-next';
import FeatureGates from '@atlaskit/feature-gate-js-client';
import { type SurfaceMetadata } from '@atlassian/ai-smart-button-api';

import type { ObjectSidebar } from './types/object-sidebar-types';
import type { AISmartButtonSidebarAPI } from './types/shared-types';

export const isObjectSidebar = (
	sidebarApi: AISmartButtonSidebarAPI | ObjectSidebar,
): sidebarApi is ObjectSidebar => {
	return (
		'state' in sidebarApi && 'actions' in sidebarApi && 'changeHeaderElements' in sidebarApi.actions
	);
};

export const createClickAnalyticsEvent = (
	createAnalyticsEvent: CreateUIAnalyticsEvent,
	surfaceMetadata: SurfaceMetadata,
) => {
	createAnalyticsEvent({
		type: 'sendUIEvent',
		data: {
			source: surfaceMetadata.contentType,
			action: 'clicked',
			actionSubject: 'rovoButton',
			actionSubjectId: 'aiRovoSmartButton',
			attributes: {
				product: surfaceMetadata.product,
				productPage: surfaceMetadata.contentType,
				pageMode: surfaceMetadata.pageMode,
			},
		},
	}).fire();
};

export const createHoverAnalyticsEvent = (
	createAnalyticsEvent: CreateUIAnalyticsEvent,
	surfaceMetadata: SurfaceMetadata,
) => {
	createAnalyticsEvent({
		type: 'sendUIEvent',
		data: {
			source: surfaceMetadata.contentType,
			action: 'hovered',
			actionSubject: 'rovoButton',
			actionSubjectId: 'aiRovoSmartButton',
			attributes: {
				product: surfaceMetadata.product,
				productPage: surfaceMetadata.contentType,
				pageMode: surfaceMetadata.pageMode,
			},
		},
	}).fire();
};

export const handleConvoStarters = (
	surfaceMetadata: SurfaceMetadata,
	setShowConvoStarters: (show: boolean) => void,
) => {
	if (surfaceMetadata.product === 'confluence') {
		setShowConvoStarters(
			FeatureGates.getExperimentValue(
				'contextual_convo_starters_in_rovo_button_panel',
				'isEnabled',
				false,
			),
		);
	} else {
		setShowConvoStarters(false);
	}
};
